import React from "react";

export function SectionHeading({ kicker, heading, subtitle, align = "left", testid }) {
  return (
    <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`} data-testid={testid}>
      {kicker && (
        <p className="text-xs sm:text-sm uppercase tracking-[0.3em] text-jlo-gold font-semibold mb-4">{kicker}</p>
      )}
      <h2 className="font-display font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-jlo-warm">
        {heading}
      </h2>
      {subtitle && <p className="mt-5 text-base sm:text-lg text-jlo-warm/70 leading-relaxed">{subtitle}</p>}
    </div>
  );
}

export function Section({ children, className = "", id, testid }) {
  return (
    <section id={id} data-testid={testid} className={`mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-20 sm:py-28 ${className}`}>
      {children}
    </section>
  );
}
